var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPigWhiteBorder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 105,
    height: 105,
    viewBox: "0 0 105 105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_159",
    "data-name": "Gruppe 159",
    transform: "translate(-1318 -1503)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 52.5,
    cy: 52.5,
    r: 52.5,
    transform: "translate(1318 1503)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_142",
    "data-name": "Pfad 142",
    d: "M938.469,1560.537a1.47,1.47,0,0,1,1.469,1.469,4.391,4.391,0,0,0,3.041,4.167c1.2-14.985,17.912-26.113,35.8-22.622a11.73,11.73,0,0,1,15.523-3.468,1.471,1.471,0,0,1,0,2.545,8.885,8.885,0,0,0-4.14,5.474,24.8,24.8,0,0,1,11.025,15.374h4.866a1.47,1.47,0,0,1,1.469,1.469V1576.7a1.47,1.47,0,0,1-1.469,1.469h-7.023a26.836,26.836,0,0,1-12.077,11.3v9.271a1.469,1.469,0,1,1-2.938,0v-7.981a33.884,33.884,0,0,1-23.507,0v7.978a1.469,1.469,0,1,1-2.938,0v-9.256c-8.342-4.117-14.072-11.609-14.612-20.269a7.349,7.349,0,0,1-5.956-7.2A1.47,1.47,0,0,1,938.469,1560.537Zm51.421,5.877a2.938,2.938,0,1,0-2.938-2.938A2.941,2.941,0,0,0,989.891,1566.414Z",
    transform: "translate(398.24 -13.852)",
    fill: "currentColor"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPigWhiteBorder);
export default __webpack_public_path__ + "static/media/pig_white_border.43c120e7a08764f05f692928762d65c8.svg";
export { ForwardRef as ReactComponent };